/*
  assets/gtender-workspace-evidence.js — GTENDER-WORKSPACE-FE-WS05
  Owner: GTender Pro Evidence workspace panel only.
  Identity / plan authority remains LittleGWebSession -> Core -> gtender_account.
  Evidence persistence remains native-subject + tender scoped behind /v1/tender/evidence.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-workspace-fe-ws05-01';
  var GLOBAL_KEY = '__GTENDER_WORKSPACE_EVIDENCE_RUNTIME__';
  var ROOT_SELECTOR = '[data-gtender-dashboard-root][data-native-session-required]';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var EVIDENCE_URL = API_ORIGIN + '/v1/tender/evidence';
  var REQUEST_TIMEOUT_MS = 10000;
  var STATUSES = Object.freeze(['missing', 'requested', 'ready', 'verified']);
  var stateByRoot = new WeakMap();

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function list(scope, selector) {
    var target = scope || document;
    var output = [];
    if (target.matches && target.matches(selector)) output.push(target);
    if (target.querySelectorAll) Array.prototype.push.apply(output, target.querySelectorAll(selector));
    return output;
  }
  function clean(value) { return String(value == null ? '' : value).trim(); }
  function validId(value) {
    var id = clean(value);
    return id && id.length <= 240 && !/[\u0000-\u001f\u007f]/.test(id) ? id : '';
  }
  function isZh(root) { return /^zh(?:-|$)/i.test(clean(root && root.getAttribute('data-locale')) || clean(document.documentElement.lang)); }
  function copy(root, zh, en) { return isZh(root) ? zh : en; }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = String(text);
    return node;
  }
  function workspace() {
    return window.GTenderWorkspace && typeof window.GTenderWorkspace.getPanelHost === 'function' ? window.GTenderWorkspace : null;
  }

  function requestJson(root, state, url, options) {
    var session = window.LittleGWebSession;
    if (!session || typeof session.authenticatedFetch !== 'function') {
      return Promise.resolve({ ok: false, status: 0, code: 'native_session_unavailable', data: {} });
    }
    if (state.requestController) state.requestController.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    state.requestController = controller;
    var requestOptions = Object.assign({}, options || {});
    requestOptions.headers = Object.assign({ Accept: 'application/json' }, requestOptions.headers || {});
    if (controller) requestOptions.signal = controller.signal;
    var timeout = null;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () {
        if (controller) controller.abort();
        var error = new Error('GTender Evidence request timed out.');
        error.code = 'gtender_evidence_timeout';
        reject(error);
      }, REQUEST_TIMEOUT_MS);
    });
    return Promise.race([session.authenticatedFetch(url, requestOptions), deadline]).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (payload) {
        return {
          ok: response.ok && payload && payload.success === true,
          status: response.status,
          code: clean(payload && payload.error && payload.error.code),
          message: clean(payload && payload.error && payload.error.message),
          data: payload && payload.data && typeof payload.data === 'object' ? payload.data : {}
        };
      });
    }).catch(function (error) {
      return { ok: false, status: 0, code: clean(error && error.code) || 'network_error', message: '', data: {} };
    }).finally(function () {
      if (timeout !== null) window.clearTimeout(timeout);
      if (state.requestController === controller) state.requestController = null;
    });
  }

  function setStatus(state, text, tone) {
    state.status.textContent = text || '';
    state.status.setAttribute('data-tone', tone || 'neutral');
  }
  function accessChanged(root, state) {
    var ws = workspace();
    if (ws) ws.disable(root, 'evidence');
    state.loaded = false;
    state.items = [];
    setStatus(state, copy(root, '正在重新核驗 GTender Pro 權限…', 'Revalidating GTender Pro access…'), 'warning');
    root.dispatchEvent(new CustomEvent('gtender-dashboard:access-refresh-required', { bubbles: true }));
  }
  function tenderTitle(tender, fallback) {
    return clean(tender && (tender.title || tender.tender_title || tender.name)) || fallback;
  }
  function statusLabel(root, status) {
    var labels = {
      missing: copy(root, '缺少', 'Missing'),
      requested: copy(root, '已要求', 'Requested'),
      ready: copy(root, '已準備', 'Ready'),
      verified: copy(root, '已核驗', 'Verified')
    };
    return labels[status] || status;
  }

  function render(root, state) {
    state.context.textContent = state.tenderId
      ? copy(root, 'Tender：', 'Tender: ') + tenderTitle(state.tender, state.tenderId)
      : copy(root, '先載入一個 tender，再管理其 Evidence。', 'Load one tender before managing its evidence.');
    state.list.replaceChildren();
    state.count.textContent = state.tenderId ? String(state.items.length) : '—';
    state.editor.hidden = !state.tenderId;
    if (!state.tenderId) return;
    if (!state.items.length) {
      var empty = element('div', 'gtender-workspace-evidence__empty');
      empty.appendChild(element('h3', '', copy(root, '尚未建立 Evidence 項目', 'No evidence items yet')));
      empty.appendChild(element('p', '', copy(root, '使用 requirement key 建立或更新同一需求的 Evidence。', 'Use a requirement key to create or update evidence for the same requirement.')));
      state.list.appendChild(empty);
      return;
    }

    state.items.forEach(function (item) {
      var evidenceId = validId(item && item.evidence_id);
      if (!evidenceId) return;
      var card = element('article', 'gtender-workspace-evidence__item');
      card.setAttribute('data-gtender-evidence-item', evidenceId);
      var head = element('div', 'gtender-workspace-evidence__head');
      var title = element('div', '');
      title.appendChild(element('strong', '', clean(item.label) || clean(item.requirement_key)));
      title.appendChild(element('span', 'gtender-workspace-evidence__badge', statusLabel(root, clean(item.status) || 'missing')));
      head.appendChild(title);
      var remove = element('button', 'gtender-workspace-evidence__button gtender-workspace-evidence__button--danger', copy(root, '刪除', 'Delete'));
      remove.type = 'button';
      remove.setAttribute('data-gtender-evidence-delete', evidenceId);
      head.appendChild(remove);
      card.appendChild(head);
      card.appendChild(element('p', 'gtender-workspace-evidence__key', clean(item.requirement_key)));
      if (clean(item.note)) card.appendChild(element('p', 'gtender-workspace-evidence__note', clean(item.note)));
      if (clean(item.source_url)) {
        var link = document.createElement('a');
        link.href = clean(item.source_url);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = copy(root, '查看 HTTPS 來源', 'Open HTTPS source');
        card.appendChild(link);
      }
      var error = element('p', 'gtender-workspace-evidence__row-error', '');
      error.setAttribute('data-gtender-evidence-row-error', evidenceId);
      error.setAttribute('aria-live', 'polite');
      card.appendChild(error);
      state.list.appendChild(card);
    });
  }

  function renderBlocked(root, state, migration) {
    state.list.replaceChildren();
    var box = element('div', 'gtender-workspace-evidence__empty');
    box.appendChild(element('h3', '', migration
      ? copy(root, 'Evidence ownership 尚未完成遷移', 'Evidence ownership migration is pending')
      : copy(root, 'Evidence 暫時無法載入', 'Evidence is temporarily unavailable')));
    box.appendChild(element('p', '', migration
      ? copy(root, '不會將 legacy customer-owned Evidence 推定為目前 native subject。', 'Legacy customer-owned evidence is not assumed to belong to the current native subject.')
      : copy(root, '現有 Evidence 資料保持不變。', 'Existing evidence remains unchanged.')));
    state.list.appendChild(box);
    state.count.textContent = '—';
  }

  function loadTender(root, state, tenderId, force) {
    tenderId = validId(tenderId || state.tenderId);
    if (!state.active || root.getAttribute('data-access-state') !== 'pro' || !tenderId) return Promise.resolve(false);
    if (state.loading) return Promise.resolve(false);
    if (state.loaded && state.tenderId === tenderId && !force) return Promise.resolve(true);
    state.loading = true;
    root.setAttribute('data-evidence-workspace-state', 'loading');
    setStatus(state, copy(root, '正在載入 Evidence…', 'Loading evidence…'), 'neutral');
    return requestJson(root, state, EVIDENCE_URL + '?tender_id=' + encodeURIComponent(tenderId), { method: 'GET' }).then(function (result) {
      if (!state.active || root.getAttribute('data-access-state') !== 'pro') return false;
      if (result.status === 401 || result.status === 403) {
        accessChanged(root, state);
        root.setAttribute('data-evidence-workspace-state', 'access-changed');
        return false;
      }
      if (result.status === 409 && result.code === 'workspace_ownership_migration_required') {
        state.loaded = false;
        renderBlocked(root, state, true);
        setStatus(state, copy(root, '未進行 ownership 推定。', 'No ownership assumption was made.'), 'warning');
        root.setAttribute('data-evidence-workspace-state', 'ownership-blocked');
        return false;
      }
      if (!result.ok || !Array.isArray(result.data.items)) {
        state.loaded = false;
        if (result.status === 404) {
          state.tenderId = '';
          state.tender = null;
          state.items = [];
          render(root, state);
          setStatus(state, copy(root, '找不到 canonical tender。', 'Canonical tender not found.'), 'warning');
        } else {
          renderBlocked(root, state, false);
          setStatus(state, copy(root, '沒有修改證明資料', 'No evidence data was changed'), 'warning');
        }
        root.setAttribute('data-evidence-workspace-state', 'unavailable');
        return false;
      }
      state.tenderId = tenderId;
      state.tender = result.data.tender || null;
      state.items = result.data.items.slice(0, 200);
      state.loaded = true;
      render(root, state);
      setStatus(state, copy(root, '已載入此 tender 的 native Evidence。', 'Native evidence for this tender is loaded.'), 'success');
      root.setAttribute('data-evidence-workspace-state', 'ready');
      return true;
    }).finally(function () { state.loading = false; });
  }

  function upsert(root, state) {
    if (!state.tenderId || state.saving) return;
    var form = state.editor;
    var sourceUrl = clean(form.elements.source_url.value).slice(0, 1000);
    if (sourceUrl && !/^https:\/\//i.test(sourceUrl)) {
      setStatus(state, copy(root, 'Evidence 來源 URL 必須使用 HTTPS。', 'Evidence source URL must use HTTPS.'), 'warning');
      form.elements.source_url.focus();
      return;
    }
    var body = {
      tender_id: state.tenderId,
      requirement_key: clean(form.elements.requirement_key.value).slice(0, 120),
      label: clean(form.elements.label.value).slice(0, 240),
      status: clean(form.elements.status.value),
      note: clean(form.elements.note.value).slice(0, 1200),
      source_url: sourceUrl
    };
    if (!body.requirement_key || !body.label || STATUSES.indexOf(body.status) < 0) {
      setStatus(state, copy(root, 'Requirement key、名稱及狀態必須有效。', 'Requirement key, label and status are required.'), 'warning');
      return;
    }
    state.saving = true;
    state.submit.disabled = true;
    setStatus(state, copy(root, '正在保存 Evidence…', 'Saving evidence…'), 'neutral');
    requestJson(root, state, EVIDENCE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || !result.data.item) {
        setStatus(state, copy(root, '未能保存 Evidence；現有資料保持不變。', 'Could not save evidence; existing data is unchanged.'), 'warning');
        return;
      }
      form.reset();
      state.loaded = false;
      return loadTender(root, state, state.tenderId, true);
    }).finally(function () {
      state.saving = false;
      state.submit.disabled = false;
    });
  }

  function rowError(state, id, text) {
    var node = state.host.querySelector('[data-gtender-evidence-row-error="' + CSS.escape(id) + '"]');
    if (node) node.textContent = text || '';
  }
  function deleteItem(root, state, evidenceId, button) {
    if (!evidenceId || state.deleting.has(evidenceId)) return;
    state.deleting.add(evidenceId);
    button.disabled = true;
    rowError(state, evidenceId, copy(root, '正在刪除…', 'Deleting…'));
    requestJson(root, state, EVIDENCE_URL + '/' + encodeURIComponent(evidenceId), { method: 'DELETE' }).then(function (result) {
      if (result.status === 401 || result.status === 403) return accessChanged(root, state);
      if (!result.ok || result.data.deleted !== true) {
        rowError(state, evidenceId, copy(root, '未能刪除；Evidence 保持不變。', 'Delete failed; evidence is unchanged.'));
        return;
      }
      state.items = state.items.filter(function (item) { return validId(item && item.evidence_id) !== evidenceId; });
      render(root, state);
      setStatus(state, copy(root, 'Evidence 已刪除。', 'Evidence deleted.'), 'success');
    }).finally(function () {
      state.deleting.delete(evidenceId);
      if (button.isConnected) button.disabled = false;
    });
  }

  function makeShell(root, host) {
    host.replaceChildren();
    var shell = element('div', 'gtender-workspace-evidence');
    shell.setAttribute('data-gtender-workspace-evidence', '');
    var header = element('div', 'gtender-workspace-evidence__header');
    var copyNode = element('div', '');
    copyNode.appendChild(element('p', 'gtender-workspace-evidence__eyebrow', 'GTender Pro'));
    copyNode.appendChild(element('h2', '', 'Evidence'));
    copyNode.appendChild(element('p', '', copy(root, 'Evidence 始終綁定一個 canonical tender 及目前 native subject。', 'Evidence is always bound to one canonical tender and the current native subject.')));
    header.appendChild(copyNode);
    var count = element('strong', 'gtender-workspace-evidence__count', '—');
    header.appendChild(count);
    shell.appendChild(header);
    var status = element('p', 'gtender-workspace-evidence__status', '');
    status.setAttribute('aria-live', 'polite');
    shell.appendChild(status);

    var loader = element('form', 'gtender-workspace-evidence__loader');
    var loadLabel = element('label', '');
    loadLabel.appendChild(element('span', '', 'Tender ID'));
    var tenderInput = document.createElement('input');
    tenderInput.type = 'text';
    tenderInput.name = 'tender_id';
    tenderInput.maxLength = 240;
    tenderInput.required = true;
    loadLabel.appendChild(tenderInput);
    var loadButton = element('button', 'gtender-workspace-evidence__button gtender-workspace-evidence__button--primary', copy(root, '載入 Evidence', 'Load evidence'));
    loadButton.type = 'submit';
    loader.appendChild(loadLabel);
    loader.appendChild(loadButton);
    shell.appendChild(loader);
    var context = element('p', 'gtender-workspace-evidence__context', '');
    shell.appendChild(context);

    var editor = element('form', 'gtender-workspace-evidence__editor');
    editor.hidden = true;
    [
      ['requirement_key', copy(root, 'Requirement key', 'Requirement key'), 'text'],
      ['label', copy(root, '需求名稱', 'Requirement label'), 'text'],
      ['source_url', copy(root, 'HTTPS 來源（可選）', 'HTTPS source (optional)'), 'url']
    ].forEach(function (field) {
      var label = element('label', '');
      label.appendChild(element('span', '', field[1]));
      var input = document.createElement('input');
      input.name = field[0];
      input.type = field[2];
      if (field[0] === 'requirement_key') input.maxLength = 120;
      if (field[0] === 'label') input.maxLength = 240;
      if (field[0] === 'source_url') input.maxLength = 1000;
      if (field[0] !== 'source_url') input.required = true;
      label.appendChild(input);
      editor.appendChild(label);
    });
    var statusLabelNode = element('label', '');
    statusLabelNode.appendChild(element('span', '', copy(root, 'Evidence 狀態', 'Evidence status')));
    var statusSelect = document.createElement('select');
    statusSelect.name = 'status';
    STATUSES.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = statusLabel(root, value);
      statusSelect.appendChild(option);
    });
    statusLabelNode.appendChild(statusSelect);
    editor.appendChild(statusLabelNode);
    var noteLabel = element('label', 'gtender-workspace-evidence__note-field');
    noteLabel.appendChild(element('span', '', copy(root, '備註（可選）', 'Note (optional)')));
    var note = document.createElement('textarea');
    note.name = 'note';
    note.maxLength = 1200;
    note.rows = 3;
    noteLabel.appendChild(note);
    editor.appendChild(noteLabel);
    var submit = element('button', 'gtender-workspace-evidence__button gtender-workspace-evidence__button--primary', copy(root, '保存 Evidence', 'Save evidence'));
    submit.type = 'submit';
    editor.appendChild(submit);
    shell.appendChild(editor);

    var listNode = element('div', 'gtender-workspace-evidence__list');
    shell.appendChild(listNode);
    host.appendChild(shell);
    return { shell: shell, count: count, status: status, loader: loader, tenderInput: tenderInput, context: context, editor: editor, submit: submit, list: listNode };
  }

  function activate(root, state) {
    var ws = workspace();
    if (!ws || root.getAttribute('data-access-state') !== 'pro') return;
    ws.enable(root, 'evidence');
    if (root.getAttribute('data-workspace-tab') === 'evidence' && state.tenderId) loadTender(root, state, state.tenderId, false);
  }
  function invalidate(root, state) {
    state.loaded = false;
    state.tenderId = '';
    state.tender = null;
    state.items = [];
    if (state.requestController) state.requestController.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'evidence');
    render(root, state);
    setStatus(state, '', 'neutral');
    root.removeAttribute('data-evidence-workspace-state');
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var ws = workspace();
    if (!ws) return;
    var host = ws.getPanelHost(root, 'evidence');
    if (!host) return;
    var ui = makeShell(root, host);
    var state = {
      active: true,
      controller: new AbortController(),
      requestController: null,
      host: host,
      shell: ui.shell,
      count: ui.count,
      status: ui.status,
      loader: ui.loader,
      tenderInput: ui.tenderInput,
      context: ui.context,
      editor: ui.editor,
      submit: ui.submit,
      list: ui.list,
      tenderId: '',
      tender: null,
      items: [],
      loaded: false,
      loading: false,
      saving: false,
      deleting: new Set()
    };
    stateByRoot.set(root, state);
    root.setAttribute('data-evidence-workspace-owner', VERSION);
    render(root, state);

    state.loader.addEventListener('submit', function (event) {
      event.preventDefault();
      var tenderId = validId(state.tenderInput.value);
      if (!tenderId) {
        setStatus(state, copy(root, '請輸入有效 tender ID。', 'Enter a valid tender ID.'), 'warning');
        return;
      }
      state.loaded = false;
      loadTender(root, state, tenderId, true);
    }, { signal: state.controller.signal });
    state.editor.addEventListener('submit', function (event) { event.preventDefault(); upsert(root, state); }, { signal: state.controller.signal });
    state.shell.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button') : null;
      if (!target || !state.host.contains(target)) return;
      var evidenceId = validId(target.getAttribute('data-gtender-evidence-delete'));
      if (evidenceId) { event.preventDefault(); deleteItem(root, state, evidenceId, target); }
    }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:pro-ready', function () { activate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-invalidated', function () { invalidate(root, state); }, { signal: state.controller.signal });
    root.addEventListener('gtender-workspace:tabchange', function (event) {
      if (event && event.detail && event.detail.tab === 'evidence' && state.tenderId) loadTender(root, state, state.tenderId, false);
    }, { signal: state.controller.signal });
    activate(root, state);
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    if (state.requestController) state.requestController.abort();
    state.controller.abort();
    var ws = workspace();
    if (ws) ws.disable(root, 'evidence');
    state.host.replaceChildren();
    root.removeAttribute('data-evidence-workspace-owner');
    root.removeAttribute('data-evidence-workspace-state');
    stateByRoot.delete(root);
  }

  function boot(scope) { list(scope || document, ROOT_SELECTOR).forEach(mount); }
  function destroyAll(scope) { list(scope || document, ROOT_SELECTOR).forEach(destroy); }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(function () { boot(document); }, 0); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });
  window.addEventListener('pageshow', function () { boot(document); });

  var api = Object.freeze({ version: VERSION, boot: boot, destroy: destroyAll, load: loadTender });
  window[GLOBAL_KEY] = api;
  window.GTenderWorkspaceEvidence = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();
